import * as React from 'react'
import type { SVGProps } from 'react'
const SvgSevenrooms = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m8.7901 8.4124c0 2.2957-1.8609 4.1565-4.1566 4.1565-2.2956 0-4.1565-1.8608-4.1565-4.1565 0-2.2956 1.8609-4.1565 4.1565-4.1565s4.1566 1.8609 4.1566 4.1565M12 2.9522c2.5099 0 4.7813 1.0223 6.4205 2.6727a5.1 5.1 0 0 0-1.7876-.3218H5.9155C7.5224 3.8422 9.6571 2.9521 12 2.9521m-.4764 7.4602v10.6224c-3.0242-.1565-5.6553-1.7988-7.1789-4.2099l7.2466-7.2466a5.13 5.13 0 0 0-.0677.8341m-7.6609 5.5479C3.2795 14.764 2.9522 13.4205 2.9522 12c0-2.1807.7714-4.1814 2.0565-5.7441h8.6522c-.269.1926-.518.41-.7441.6497zm8.6137 5.0751v-7.6515c.2105.2938.4515.5646.718.8074l4.6857 4.6857c-1.4689 1.2571-3.3453 2.0516-5.4037 2.1584m6.0938-2.8149-2.7659-2.7658c.2696.044.546.067.828.067 1.8379 0 3.4497-.9708 4.3497-2.4273-.2379 1.9751-1.1125 3.7541-2.4118 5.1261"
    />
  </svg>
)
export default SvgSevenrooms
